<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'SkinTheme',
  beforeCreate() {
    this.$store.commit('INIT_SKIN', this.$zwxLocalStorage.getLocalStorageDefault('skin-theme', 'default'))
  },
  computed: {
    win() {
      return window.top === undefined || window.top === null || window.top.vm === undefined || window.top.vm === null ? window : window.top
    },
    skin() {
      if (this.win.vm !== undefined) return this.win.vm.$store.state.skin
      return this.$store.state.skin
    },
    skinClass() {
      return 'skin-theme-' + this.skin
    },
  },
  watch: {
    skinClass: {
      handler(newValue) {
        document.getElementsByTagName('body')[0].className = newValue
      },
      immediate: true,
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
